import { faEdit, faExclamation, faExclamationCircle, faLock, faLockOpen, faPlusSquare, faSave, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { memo, useContext, useState } from 'react';
import { Handle, useReactFlow, useStoreApi, Position } from 'reactflow';
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import AppContext from '../../../contexts/AppContext';
import getTailwindBgColor from '../getTailwindBgColor';

function AltImpact({ id, data }) {
    const [lockedByUsername, setLockedByUsername] = useState(data.lockedByUsername)
    const [text, setText] = useState(data.text)
    const { user } = useContext(AppContext);
    const keys = Object.keys(data.handles);

    return (
        <div className={`cursor-pointer p-2 shadow-lg rounded-xl ${data.isSelected ? data.showGroup ? 'shadow-teal-400 border-4 border-teal-400' : 'shadow-orange-600 border-4 border-orange-600' : ''}`} onClick={() => {
            if (data.showCount) {
                if ((data.isAddMode && data.countId) ||
                    (data.selectedCountId && (!data.isAddMode && !data.isDeleteMode)) ||
                    (data.isDeleteMode && (data.selectedCountId !== data.countId))) {
                    return
                }
            } else if (data.showGroup) {
                if ((data.isAddMode && data.groupId) ||
                    (data.selectedGroupId && (!data.isAddMode && !data.isDeleteMode)) ||
                    (data.isDeleteMode && (data.selectedGroupId !== data.groupId))) {
                    return
                }
            }

        
            if (data.showGroup) {
                data.setSelected(prevSelected => {
                    const additions = data.isDeleteMode ? [id] : data.getRelatedGroupNodeIds(id)
                    if (prevSelected.includes(id)) {
                        return prevSelected.filter(nid => !additions.includes(nid));
                    } else {
                        return [...prevSelected, ...additions];
                    }
                });
                return
            }
            

            data.setSelected(prevSelected => {
                // Using the includes method instead of find for readability.
                if (prevSelected.includes(id)) {
                    return prevSelected.filter(nid => nid !== id);
                } else {
                    return [...prevSelected, id];
                }
            });
        }}>
            <div
                
                className={`custom-node__header ${getTailwindBgColor(data.colorNumber)} flex justify-between rounded-t-lg`}>
                <strong>Impact</strong>
                <div data-tooltip-content={`${data.prioritized ? 'prioritized' : 'not prioritized'}`} data-tooltip-id='prioritize'
                    className={`bg-gradient-to-r from-gray-200 to-white ml-2 px-[4px] rounded cursor-pointer ${data.prioritized ? 'text-teal-600' : 'text-gray-600'}`}>
                    <FontAwesomeIcon icon={faExclamationCircle} size='md' />
                </div>
                <Tooltip place='top' id='prioritize' />
                {
                    data.rank ? (
                        <>
                            <div data-tooltip-content={`Impact rank`} data-tooltip-id='rank'
                                className={`${getTailwindBgColor(data.rank)} text-white ml-2 w-6 font-semibold rounded cursor-pointer flex items-center justify-center`}>
                                {data.rank}
                            </div>
                            <Tooltip place='top' id='rank' /></>
                    ): null
                }
            </div>
            <div className="custom-node__header bg-zinc-200 flex justify-between">

                {data.showCount && <div className={`mx-2 truncate w-[200px] rounded font-semibold transition-all ease-linear duration-300 ${data.showCount ? data.countId ? 'text-orange-600 opacity-100' : 'text-red-600 opacity-100' : 'opacity-0'}`}>
                    <strong className='text-sm font-[400]'>{data.countId ? data.countUpdated ? data.countUpdated : data.count.countDescription : 'none'}</strong>
                </div>}

                {data.showGroup && <div className={`mx-2 truncate w-[200px] rounded font-semibold transition-all ease-linear duration-300 ${data.showGroup ? data.groupId ? 'text-teal-600 opacity-100' : 'text-red-600 opacity-100' : 'opacity-0'}`}>
                    <strong className='text-sm font-[400]'>{data.groupId ? data.groupUpdated ? data.groupUpdated : data.group.groupName : 'none'}</strong>
                </div>}

            </div>
            <div className="custom-node__body flex bg-gray-100 rounded-b-xl">
                
                <textarea
                    value={text}
                    placeholder={'Consequence description'}
                    rows={"4"} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 
                    leading-tight focus:outline-none focus:shadow-outline"
                />
            </div>
        </div>
    );
}

export default memo(AltImpact);
